import { useEffect, useState } from 'react';

import { callUserInfoAPI } from '../shared/APIHelper';
import { utf8SafeDecode } from '../shared/UtilFunctions';
import { getFormattedUserNameWithId } from '../shared/UserLogin';
import { Autocomplete, TextField } from '@mui/material';

export default function StakeHolderUserFilter(props) {
  const { setStatusErrorMsg, decrementAPIInProgress, incrementAPIInProgress } =
    props.commonProps;
  const {
    setSelectedStakeHolderIds,
    selectedValues,
    setUserMapFn,
    stakeHolderList
  } = props;
  const [tmpUserList, setTmpUserList] = useState(null);
  const [userList, setUserList] = useState(null);

  useEffect(() => {
    if (stakeHolderList?.length > 0) {
      callUserInfoAPI(
        stakeHolderList,
        setUserMapFn,
        setTmpUserList,
        incrementAPIInProgress,
        decrementAPIInProgress,
        setStatusErrorMsg
      );
    }
  }, [stakeHolderList]);

  useEffect(() => {
    if (tmpUserList?.length > 0) {
      // Sort by Last Name, first name
      const sortedList = [...tmpUserList].sort((a, b) => {
        let cmp = a.lastName.localeCompare(b.lastName);

        if (cmp === 0) cmp = a.firstName.localeCompare(b.firstName);
        return cmp;
      });

      const data = sortedList.map((item) => ({
        value: item.id,
        label: utf8SafeDecode(getFormattedUserNameWithId(item, item.id))
      }));
      setUserList(data);
    }
  }, [tmpUserList]);
  return (
    <>
      {userList && (
        <Autocomplete
          multiple
          fullWidth
          id="user-filter-dropdown"
          data-testid="user-filter-dropdown"
          key={selectedValues?.length}
          value={selectedValues || []}
          options={[...userList, { value: '', label: '' }]}
          getOptionLabel={(option) => option.label ?? option?.value}
          isOptionEqualToValue={(option, chosen) =>
            option.value === chosen?.value
          }
          filterSelectedOptions
          onChange={(_, values) => setSelectedStakeHolderIds(values)}
          renderValue={() => null}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={
                !selectedValues || selectedValues.length === 0
                  ? 'Search by ID or Name'
                  : `${selectedValues.length} users selected`
              }
            />
          )}
          sx={{
            width: '100%',
            minWidth: 0,
            '& .MuiAutocomplete-inputRoot': {
              alignItems: 'center',
              flexWrap: 'nowrap',
              overflow: 'hidden'
            },
            '& .MuiChip-root': {
              maxWidth: 'calc(100% - 2.5rem)',
              fontSize: '0.875rem'
            },
            '& .MuiChip-label': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }
          }}
        />
      )}
    </>
  );
}
